(function(root){
'use strict';
const models={"5-30": {"family": "video", "label": "5th Gen 30GB", "codes": "MA002 / MA146 / PA002 / PA146", "tracks": 20000, "capacities": [128, 256, 512, 1024], "ribbon": false}, "5-60": {"family": "video", "label": "5th Gen 60GB", "codes": "MA003 / MA147 / PA003 / PA147", "tracks": 50000, "capacities": [128, 256, 512, 1024], "ribbon": false}, "55-30": {"family": "video", "label": "5.5th Gen 30GB", "codes": "MA444 / MA446 / PA444 / PA446 / MA664", "tracks": 20000, "capacities": [128, 256, 512, 1024], "ribbon": false}, "55-80": {"family": "video", "label": "5.5th Gen 80GB", "codes": "MA448 / MA450 / PA448 / PA450", "tracks": 50000, "capacities": [128, 256, 512, 1024], "ribbon": false}, "6-80": {"family": "classic", "label": "6th Gen 80GB", "codes": "MB029 / MB147 / PB029", "tracks": 50000, "capacities": [128], "ribbon": false}, "6-160": {"family": "classic", "label": "6th Gen 160GB thick", "codes": "MB145 / MB150 / PB145 / PB150", "tracks": 50000, "capacities": [128], "ribbon": true}, "65-120": {"family": "classic", "label": "6.5th Gen 120GB", "codes": "MB565 / PB565 / MB562 / PB562", "tracks": 50000, "capacities": [128], "ribbon": false}, "7-160": {"family": "classic", "label": "7th Gen 160GB thin", "codes": "PC297 / MC297 / PC293 / MC293", "tracks": 50000, "capacities": [128, 256, 512, 1024], "ribbon": false}};
const variants={"51655099744534": {"family": "classic", "capacity": 128, "handle": "ipod-classic-6th-7th-gen-flash-upgrade"}, "51655099777302": {"family": "classic", "capacity": 256, "handle": "ipod-classic-6th-7th-gen-flash-upgrade"}, "51655099810070": {"family": "classic", "capacity": 512, "handle": "ipod-classic-6th-7th-gen-flash-upgrade"}, "51655099842838": {"family": "classic", "capacity": 1024, "handle": "ipod-classic-6th-7th-gen-flash-upgrade"}, "51738020610326": {"family": "video", "capacity": 128, "handle": "ipod-video-5th-gen-flash-upgrade"}, "51738020643094": {"family": "video", "capacity": 256, "handle": "ipod-video-5th-gen-flash-upgrade"}, "51738020675862": {"family": "video", "capacity": 512, "handle": "ipod-video-5th-gen-flash-upgrade"}, "51738020708630": {"family": "video", "capacity": 1024, "handle": "ipod-video-5th-gen-flash-upgrade"}};
function allowed(model,id){
 const m=models[model],v=variants[String(id)];
 return !!(m&&v&&m.family===v.family&&m.capacities.includes(v.capacity));
}
function validate(items){
 for(const item of items){
  const id=String(item.variant_id||item.id),p=item.properties||{};
  if(!variants[id])continue;
  const model=p['_SR034 model'];
  if(!allowed(model,id)||p['iPod operating system']!=='Stock Apple OS'||p['iPod model']!==models[model].label)
   return 'Please identify your exact iPod model and choose a compatible capacity on the upgrade page before checking out.';
  if(models[model].family==='video'&&p['Library guidance acknowledged']!=='Yes')
   return 'Please review the library guidance for your iPod model on the upgrade page before checking out.';
 }
 return '';
}
const api={models,variants,allowed,validate};
root.SRiPodStorage=api;
if(typeof module!=='undefined'&&module.exports)module.exports=api;
})(typeof window==='undefined'?globalThis:window);

/* Express is a paid cart item, not just text in the repair summary. */
(function (root) {
  'use strict';
  const feeIds = ['51240799928598', '51240799961366'];
  const message = 'Your Express repair and surcharge no longer match. Remove the affected repair and its Express surcharge, then add the repair again with your preferred speed.';
  const props = item => item.properties || {};
  const isFee = item => feeIds.includes(String(item.variant_id || item.id)) || props(item)['_Add-on'] === 'Express surcharge';
  const isExpress = item => !isFee(item) && (props(item)._Express_variant || /\bExpress\b/i.test(props(item)['Repair summary'] || ''));
  const isPostage = item => props(item)['_Add-on'] === 'Return postage' || Boolean(props(item)['_Linked diagnosis'] && props(item)['_Return method']);
  const isMailin = item => !isPostage(item) && !isFee(item) && Boolean(props(item)._Return_group || props(item)['Return method'] || /\bMail-in\b/i.test(props(item)['Repair summary'] || props(item)['Diagnosis summary'] || ''));
  const titleOf = item => item.product_title || item.title;
  const isExtra = item => /battery|protector/i.test(props(item)['_Add-on'] || '');
  const isRepair = item => !isExtra(item) && !isFee(item) && !isPostage(item);
  const extraMessage = 'Your repair and optional extras no longer match. Remove the affected extra or configure the repair again.';
  function linkExtras(items) {
    const repair = items[0], extras = items.filter(isExtra);
    if (!extras.length) return;
    if (!repair || !isRepair(repair)) throw new Error(extraMessage);
    const group = root.crypto.randomUUID();
    Object.assign(repair.properties, {_Repair_group: group});
    extras.forEach(extra => Object.assign(extra.properties, {_Repair_group: group}));
  }
  function extraMatches(repair, extra) {
    const r = props(repair), e = props(extra);
    return e._Repair_group ? r._Repair_group === e._Repair_group
      : !r._Repair_group && Boolean(e['_Linked repair']) && e['_Linked repair'] === titleOf(repair);
  }
  function validateExtras(items) {
    return items.filter(isExtra).some(extra => {
      const matches = items.filter(item => isRepair(item) && extraMatches(item, extra));
      return matches.length !== 1 || Number(matches[0].quantity) !== Number(extra.quantity);
    }) ? extraMessage : '';
  }
  const returnMessage = 'Your repair and return postage no longer match. Remove the affected items and add the repair again with your preferred return postage.';
  function linkPostage(items) {
    const postage = items.filter(isPostage);
    if (!postage.length) return;
    if (postage.length !== 1 || !items[0] || isPostage(items[0])) throw new Error(returnMessage);
    const group = root.crypto.randomUUID();
    Object.assign(items[0].properties, {_Return_group: group, _Return_variant: String(postage[0].id)});
    Object.assign(postage[0].properties, {_Return_group: group});
  }
  function returnMatches(repair, fee) {
    const p = props(repair), f = props(fee);
    return p._Return_group ? f._Return_group === p._Return_group : !f._Return_group && (f['_Linked repair'] || f['_Linked diagnosis']) === titleOf(repair);
  }
  function validatePostage(items) {
    const repairs = items.filter(isMailin), postage = items.filter(isPostage);
    for (const repair of repairs) {
      const matches = postage.filter(fee => returnMatches(repair, fee));
      if (!matches.length) return returnMessage;
      if (props(repair)._Return_group && (matches.length !== 1 || Number(matches[0].quantity) !== Number(repair.quantity) || String(matches[0].variant_id || matches[0].id) !== props(repair)._Return_variant)) return returnMessage;
    }
    return postage.some(fee => !repairs.some(repair => returnMatches(repair, fee))) ? returnMessage : '';
  }
  function linkStorageBattery(items) {
    const repair = items[0];
    if (!repair || !root.SRiPodStorage?.variants[String(repair.id)]) return;
    const batteries = items.filter(item => /battery/i.test(props(item)['_Add-on'] || ''));
    if (!batteries.length) return;
    const group = root.crypto.randomUUID();
    Object.assign(repair.properties, {_Storage_battery_group: group});
    batteries.forEach(item => Object.assign(item.properties, {_Storage_battery_group: group}));
  }
  function validateStorageBattery(items) {
    const batteries = items.filter(item => props(item)._Storage_battery_group && /battery/i.test(props(item)['_Add-on'] || ''));
    return batteries.some(battery => !items.some(repair =>
      root.SRiPodStorage?.variants[String(repair.variant_id || repair.id)] &&
      props(repair)._Storage_battery_group === props(battery)._Storage_battery_group &&
      Number(repair.quantity) === Number(battery.quantity)
    )) ? 'Your iPod battery add-on needs its matching storage upgrade. Remove the battery add-on or configure the upgrade again.' : '';
  }
  function linkedUpdates(items, item, quantity) {
    const updates = {[item.key]: quantity};
    if (isRepair(item)) {
      items.filter(isExtra).forEach(extra => {
        if (!extraMatches(item, extra)) return;
        const parents = items.filter(repair => isRepair(repair) && extraMatches(repair, extra));
        if (parents.length === 1) updates[extra.key] = quantity;
      });
    }
    if (isExpress(item)) {
      const group = props(item)._Express_group;
      const sameTitle = items.filter(line => isExpress(line) && !props(line)._Express_group && titleOf(line) === titleOf(item));
      items.filter(isFee).forEach(fee => {
        if (group ? props(fee)._Express_group === group : sameTitle.length === 1 && !props(fee)._Express_group && props(fee)['_Linked repair'] === titleOf(item)) updates[fee.key] = quantity;
      });
    }
    if (isMailin(item)) {
      items.filter(isPostage).forEach(fee => {
        if (!returnMatches(item, fee)) return;
        if (props(item)._Return_group) updates[fee.key] = quantity;
        else if (quantity === 0 && !items.some(other => other.key !== item.key && isMailin(other) && returnMatches(other, fee))) updates[fee.key] = 0;
      });
    }
    if (root.SRiPodStorage?.variants[String(item.variant_id || item.id)] && props(item)._Storage_battery_group) {
      items.filter(line => /battery/i.test(props(line)['_Add-on'] || '') && props(line)._Storage_battery_group === props(item)._Storage_battery_group)
        .forEach(line => { updates[line.key] = quantity; });
    }
    return updates;
  }
  function validate(items, prices = {}) {
    const repairs = items.filter(isExpress), fees = items.filter(isFee);
    const used = new Set();
    for (const repair of repairs) {
      const p = props(repair);
      // Old carts have only a title link; ambiguous matches must be reconfigured.
      const matches = fees.filter(fee => p._Express_group
        ? props(fee)._Express_group === p._Express_group
        : !props(fee)._Express_group && props(fee)['_Linked repair'] === (repair.product_title || repair.title));
      if (matches.length !== 1) return message;
      const fee = matches[0];
      if (used.has(fee) || Number(fee.quantity) !== Number(repair.quantity) ||
          Number(fee.original_price ?? fee.price) !== Number(prices[String(fee.variant_id || fee.id)]) ||
          !feeIds.includes(String(fee.variant_id || fee.id)) ||
          (p._Express_variant && String(fee.variant_id || fee.id) !== String(p._Express_variant))) return message;
      used.add(fee);
    }
    return used.size === fees.length ? '' : message;
  }
  function attach(items, surcharge, map, label, title) {
    if (!surcharge) return;
    const id = String(map.expressSurchargeVariantId || '');
    if (!Number.isInteger(Number(surcharge)) || Number(surcharge) <= 0 || Number(surcharge) !== Number(map.expressSurchargePrice) || !feeIds.includes(id)) {
      throw new Error('Express is temporarily unavailable. Please select standard service or contact us.');
    }
    const group = root.crypto.randomUUID();
    Object.assign(items[0].properties, {_Express_group: group, _Express_variant: id});
    items.push({id: Number(id), quantity: items[0].quantity, properties: {
      _Express_group: group, _Express_price: String(surcharge), '_Linked repair': title, '_Add-on': 'Express surcharge', _Speed: label
    }});
  }
  const route = path => (root.Shopify?.routes?.root || '/') + path;
  async function add(items) {
    linkPostage(items);
    linkStorageBattery(items);
    linkExtras(items);
    const extraError = validateExtras(items);
    if (extraError) throw new Error(extraError);
    const storageError=root.SRiPodStorage?.validate(items);
    if(storageError)throw new Error(storageError);
    for (const fee of items.filter(isFee)) {
      const response = await root.fetch(route('variants/' + fee.id + '.js'), {cache: 'no-store'});
      if (!response.ok) throw new Error('Unable to check Express availability. Please try again.');
      const variant = await response.json();
      if (!feeIds.includes(String(fee.id)) || !variant.available || !Number.isInteger(Number(variant.price)) || Number(variant.price) <= 0 || Number(variant.price) !== Number(props(fee)._Express_price)) throw new Error('Express is temporarily unavailable. Please select standard service or contact us.');
    }
    return root.fetch(route('cart/add.js'), {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items})});
  }
  const api = {attach, add, validate, linkPostage, linkedUpdates, validatePostage, linkStorageBattery, validateStorageBattery, linkExtras, validateExtras};
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.SRExpress = api;
  if (!root.document) return;
  let checking = false;
  let replaying = false;
  async function checkout(event) {
    if (replaying) return;
    const control = event.type === 'click' ? event.target.closest('[name="checkout"], a[href="/checkout"]') : event.submitter;
    if (!control || !(control.name === 'checkout' || control.getAttribute('href') === '/checkout')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checking) return;
    checking = true;
    try {
      const form = control.form;
      // Unsaved quantity edits must be applied before checking the cart.
      if (form && Array.from(form.querySelectorAll('[name="updates[]"]')).some(input => input.defaultValue !== input.value)) {
        throw new Error('Please update your cart quantities before checking out.');
      }
      const response = await root.fetch(route('cart.js'), {cache: 'no-store'});
      if (!response.ok) throw new Error('Unable to check your cart. Please try again.');
      const items = (await response.json()).items || [];
      const prices = {};
      for (const fee of items.filter(isFee)) {
        const id = String(fee.variant_id || fee.id);
        if (!feeIds.includes(id)) throw new Error(message);
        const check = await root.fetch(route('variants/' + id + '.js'), {cache: 'no-store'});
        if (!check.ok) throw new Error('Unable to check Express availability. Please try again.');
        const variant = await check.json();
        if (!variant.available || Number(variant.price) <= 0) throw new Error(message);
        prices[id] = Number(variant.price);
      }
      const error = root.SRiPodStorage?.validate(items) || validate(items, prices) || validatePostage(items) || validateStorageBattery(items) || validateExtras(items);
      if (error) throw new Error(error);
      // Replay the original action so theme terms checks, cart notes and normal
      // form submission keep working after validation.
      replaying = true;
      try {
        if (event.type === 'click') control.click();
        else form.requestSubmit(control);
      } finally { replaying = false; }
    } catch (error) {
      let notice = root.document.getElementById('sr-express-cart-error');
      if (!notice) {
        notice = root.document.createElement('p');
        notice.id = 'sr-express-cart-error';
        notice.setAttribute('role', 'alert');
        notice.setAttribute('tabindex', '-1');
        control.insertAdjacentElement('beforebegin', notice);
      }
      notice.textContent = error.message;
      notice.focus();
    } finally { checking = false; }
  }
  async function auditStorageCart(){
    const controls=Array.from(root.document.querySelectorAll('[name="checkout"],a[href="/checkout"]'));
    if(!controls.length)return;
    try{
      const response=await root.fetch(route('cart.js'),{cache:'no-store'});
      if(!response.ok)throw new Error('Unable to check iPod compatibility. Reload your cart before checkout.');
      const error=root.SRiPodStorage?.validate((await response.json()).items||[]);
      if(!error)return;
      controls.forEach(control=>{
        const notice=root.document.createElement('p');
        notice.className='sr-ipod-cart-error';notice.setAttribute('role','alert');notice.textContent=error;
        control.insertAdjacentElement('beforebegin',notice);
        control.setAttribute('aria-disabled','true');
        if(control.tagName==='BUTTON')control.disabled=true;
      });
    }catch(error){
      // The click/submit guard still prevents checkout if the cart cannot be checked.
    }
  }
  if(root.document.readyState==='loading')root.document.addEventListener('DOMContentLoaded',auditStorageCart,{once:true});else auditStorageCart();
  root.document.addEventListener('click', checkout, true);
  let changing = false;
  async function changeLine(control, key, quantity) {
    if (changing) return;
    changing = true;
    try {
      if (!Number.isInteger(quantity) || quantity < 0) throw new Error('Please enter a valid quantity.');
      const response = await root.fetch(route('cart.js'), {cache: 'no-store'});
      if (!response.ok) throw new Error('Unable to check your cart. Please try again.');
      let items = (await response.json()).items || [];
      let item = items.find(line => line.key === key);
      if (!item) { root.location.reload(); return; }
      let updates = linkedUpdates(items, item, quantity);
      if (quantity > 0) {
        const changed = await root.fetch(route('cart/change.js'), {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({id: item.key, quantity})});
        if (!changed.ok) throw new Error('Unable to change this quantity. Please try again.');
        items = (await changed.json()).items || [];
        const currentKeys = new Set(items.map(line => line.key));
        delete updates[item.key];
        updates = Object.fromEntries(Object.entries(updates).filter(([lineKey]) => currentKeys.has(lineKey)));
      }
      if (Object.keys(updates).length) {
        const changed = await root.fetch(route('cart/update.js'), {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({updates})});
        if (!changed.ok) throw new Error('Unable to update the linked items. Please try again.');
      }
      root.location.reload();
    } catch (error) {
      let notice = root.document.getElementById('sr-express-cart-error');
      if (!notice) { notice = root.document.createElement('p'); notice.id = 'sr-express-cart-error'; notice.setAttribute('role', 'alert'); control.insertAdjacentElement('afterend', notice); }
      notice.textContent = error.message;
    } finally { changing = false; }
  }
  root.document.addEventListener('click', function (event) {
    const remove = event.target.closest('[data-sr-line-key]');
    const button = event.target.closest('.quantity .minus, .quantity .plus');
    const input = button && button.parentElement.querySelector('[name="updates[]"][data-id]');
    if (!remove && !input) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const quantity = remove ? 0 : Math.max(0, Number(input.value) + (button.matches('.minus') ? -1 : 1));
    changeLine(remove || input, remove ? remove.dataset.srLineKey : input.dataset.id, quantity);
  }, true);
  root.document.addEventListener('change', function (event) {
    const input = event.target.closest('[name="updates[]"][data-id]');
    if (!input) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    changeLine(input, input.dataset.id, Number(input.value));
  }, true);
  root.document.addEventListener('submit', checkout, true);
})(typeof window === 'undefined' ? globalThis : window);




